import React, { useEffect, useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { StaticImage } from "gatsby-plugin-image"

const FirstLetter = () => {
  const {
    setFirstName,
    selectedSign,
    firstName,
    mainAudio,
    setCurrentAudioStage,
    setCurrentStep,
    audioEnded,
    currentAudioStage,
    setAudioEnded,
  } = useSiteContext()

  const [disappearing, setDisappearing] = useState(false)
  const [renderedCharacters, setRenderedCharacters] = useState([])

  useEffect(() => {
    const characterArray = firstName.split("")
    const delay = 8000 / characterArray.length

    characterArray.forEach((char, index) => {
      setTimeout(() => {
        setRenderedCharacters(prevChars => [...prevChars, char])
      }, index * delay)
    })

    const isFirefox = navigator.userAgent.toLowerCase().includes("firefox")

    if (isFirefox) {
      // Custom smooth scroll for Firefox
      const smoothScrollToTop = () => {
        let currentScroll = window.scrollY
        if (currentScroll > 0) {
          window.scrollTo(0, currentScroll - currentScroll / 8) // Adjust easing factor if needed
          requestAnimationFrame(smoothScrollToTop)
        }
      }
      requestAnimationFrame(smoothScrollToTop)
    } else {
      // Native smooth scroll for Chrome, Safari, and others
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }
  }, [])

  useEffect(() => {
    if (audioEnded) {
      // Go to next clip
      const filename = mainAudio.src.split("/").pop()
      mainAudio.pause()

      if (currentAudioStage === "first-letter") {
        setCurrentAudioStage("each-letter-serves")
        mainAudio.src = "/audio/each-letter-serves.mp3"
        mainAudio.play()
        setAudioEnded(false)
      } else if (currentAudioStage === "each-letter-serves") {
        setCurrentAudioStage("first-id-like")
        mainAudio.src = `/audio/first-id-like-${selectedSign.toLowerCase()}.mp3`
        mainAudio.play()
        setAudioEnded(false)
      } else {
        setDisappearing(true)
        setTimeout(() => {
          setCurrentAudioStage("lets-begin")
          mainAudio.src = `/audio/lets-begin.mp3`
          mainAudio.play()
          setAudioEnded(false)
          setCurrentStep(5)
        }, 700)
      }
    }
  }, [audioEnded])

  return (
    <>
      <div
        className={`text-center mt-12 fade-in flex gap-y-2 justify-center flex-wrap ${
          disappearing ? "disappear transition duration-1000" : ""
        }`}
      >
        {/* Render each character */}
        {renderedCharacters.map((char, index) => (
          <div
            key={index}
            style={{
              flex: "0 0 calc(12.5%)", // Maximum of 8 columns per row
            }}
          >
            <div className="relative flex justify-center fade-in-slow">
              <StaticImage
                quality={95}
                loading={"eager"}
                src="../images/scroll.png"
                placeholder="blurred"
                alt=""
                className={`w-full h-full max-h-24 max-w-16`}
              />
              <p className="absolute text-2xl font-extrabold text-black -translate-x-1/2 -translate-y-1/2 sm:text-3xl left-1/2 top-1/2">
                {char.toUpperCase()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default FirstLetter
